/**
 * studio-shop D4, web-studio-sites D7: what the window's current state requires a drawing to show: nothing while
 * it is closed, loading or missing; the product's name and a price while it shows one; and why no more fits, when
 * an add was refused.
 */
import type { RequiredParts } from '../../contract/required';
import type { ShopProductState } from './contract';

export const requiredParts: RequiredParts<ShopProductState> = (state) =>
  state.status !== 'ready' ? [] : [{ part: 'title' }, { part: 'price' }, ...(state.full ? [{ part: 'full' }] : [])];
